export class CourseFilter {
    id?: number;
    title?: string;
    students?: number;

    static fromJson(fields: any): CourseFilter {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
